export enum KartleggingSide {
  Kategori = 0,
  Sporsmal = 1,
}
